import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { memo } from 'react';
import { css, jsx } from '@emotion/core';
import GlobalTheme from '@atlaskit/theme/components';
import { sizes } from '../constants';
import { getBackground } from './utils';
export const IconWrapper = /*#__PURE__*/memo(function IconWrapper({
  primaryColor,
  secondaryColor,
  size,
  mode,
  ...rest
}) {
  return jsx("span", _extends({
    css: css`
        ${size && `height: ${sizes[size]}`};
        ${size && `width: ${sizes[size]}`};
        color: ${primaryColor || 'currentColor'};
        display: inline-block;
        fill: ${secondaryColor || getBackground(mode)};
        flex-shrink: 0;
        line-height: 1;

        > svg {
          ${size && `height: ${sizes[size]}`};
          ${size && `width: ${sizes[size]}`};
          max-height: 100%;
          max-width: 100%;
          overflow: hidden;
          pointer-events: none;
          vertical-align: bottom;
        }

        /**
        * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
        * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
        * rule) and then override it with currentColor for the color changes to be picked up.
        */
        stop {
          stop-color: currentColor;
        }
      `
  }, rest));
});
const Icon = /*#__PURE__*/memo(function Icon(props) {
  const {
    glyph: Glyph,
    dangerouslySetGlyph,
    primaryColor,
    secondaryColor,
    size,
    testId,
    label
  } = props;
  const glyphProps = dangerouslySetGlyph ? {
    dangerouslySetInnerHTML: {
      __html: dangerouslySetGlyph
    }
  } : {
    children: Glyph ? jsx(Glyph, {
      role: "presentation"
    }) : null
  };
  return jsx(GlobalTheme.Consumer, null, ({
    mode
  }) => jsx(IconWrapper, _extends({
    mode: mode,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    size: size,
    "data-testid": testId,
    role: label ? 'img' : 'presentation',
    "aria-label": label ? label : undefined
  }, glyphProps)));
});
export default Icon;